<template>
    <div>
        <a-form class="ant-advanced-search-form" :form="form">
            <div class="details">
                <h2>信息</h2>
                <a-row :gutter="24">
                    <a-col :span="12">
                        <a-form-item label="具体位置" v-bind="formItemLayout">
                            <a-input :disabled="lovk" placeholder="请输入"  v-decorator="['posAddress']"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-item label="SN/IMEI号" :label-col="{span : 3}" :wrapper-col="{ span: 21 }">
                            <a-input :disabled="lovk" placeholder="请输入"  v-decorator="['deviceSn']" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="12">
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="预警类型" v-bind="formItemLayoutSmall">
                                    <a-input :disabled="lovk" placeholder="请输入"  v-decorator="['warnTypeName']"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="预警时间" v-bind="formItemLayoutSmall">
                                    <a-input :disabled="lovk" placeholder="请输入"  v-decorator="['warnTimeStr']"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="12">
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="设备小类" v-bind="formItemLayoutSmall" >
                                    <a-input :disabled="lovk" placeholder="请输入"  v-decorator="['deviceTypeName']"/>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="处理状态" v-bind="formItemLayoutSmall" :wrapper-col="{ span: 18 }">
                                    <a-input :disabled="lovk" placeholder="请输入"  v-decorator="['isDeal']"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item label="预警内容" :label-col="{span: 3}" :wrapper-col="{ span: 20 }">
                        <a-textarea :disabled="lovk" placeholder="请输入"  v-decorator="['warnMessageCotent']"/>
                      </a-form-item>
                    </a-col>
                </a-row>
            </div>
            <div class="processing">
                <h2>处理</h2>
                <!-- <div v-if="formList"> -->
                  <!-- <div v-for="(item, index) in formList" :key="index"> -->
                      <a-row style="margin-top:20px">
                      <a-col :span="24">
                          <a-form-item label="处理人" v-bind="formItemLayoutProcessing">
                              <a-input :disabled="lovk" placeholder="请输入" v-decorator="['dealName']"/>
                          </a-form-item>
                      </a-col>
                      <a-col :span="24">
                          <a-form-item label="处理结果" v-bind="formItemLayoutProcessing">
                              <!-- <a-select :disabled="lovk" v-decorator="['processingResult']" placeholder="请选择"> -->
                                  <!-- <a-select-option value="0">全部</a-select-option> -->
                                  <a-input :disabled="lovk" placeholder="请输入" v-decorator="['isDeal']"/>
                            <!-- <span :disabled="lovk">{{isDeal}}</span> -->
                              <!-- </a-select> -->
                          </a-form-item>
                      </a-col>
                      <a-col :span="24">
                          <a-form-item label="图片展示" :label-col = "{ span: 2 }">
                              <div v-if='warnImageUrl' style="width:90%;margin-left:8%">
                                  <img  :src="warnImageUrl" alt="" class="upload">
                              </div>
                              <div v-else> 暂无内容 </div>
                          </a-form-item>
                      </a-col>
                      <a-col :span="24">
                            <a-form-item label="备注" v-bind="formItemLayoutProcessing">
                                <a-textarea :disabled="lovk" v-decorator="['dealRemark']" placeholde="处理意见描述文案说明。" :rows="4"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                  </div>
                <!-- </div> -->
                <!-- <div v-else style="text-align: center"> 暂无信息 </div> -->
            <!-- </div> -->
        </a-form>
        <a-button style="margin-left:10%" @click="$router.push({name: 'warning'})">返回</a-button>
    </div>
</template>

<script>
import { StrategyWarningDetails } from '@/http/device'
import moment from 'moment'
export default {
  mounted () {
    this.autoMove()
  },
  data () {
    return {
      lovk: true, // 输入框是否可编写 默认不可编辑
      warnId: this.$route.params.warnId, // 查询使用id
      form: this.$form.createForm(this),
      formList: {}, // 信息部分的数据
      formItemLayout: {
        labelCol: { span: 3 },
        wrapperCol: { span: 20 }
      },
      formItemLayoutSmall: {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 }
      },
      formItemLayoutProcessing: {
        labelCol: { span: 2 },
        wrapperCol: { span: 10 }
      },
      warnTimeStr: '', // 显示时间使用,
      warnImageUrl: ''
    }
  },
  methods: {
    moment,
    autoMove () {
      let params = {
        warnId: this.warnId
      }
      StrategyWarningDetails(params).then(res => {
        if (res.data.code === 10000) {
          let obj = res.data.data
          this.warnImageUrl = obj.warnImageUrl
          this.form.setFieldsValue({
            deviceSn: obj.deviceSn, // 设备Sn
            deviceTypeName: obj.deviceTypeName, // 设备小类
            isDeal: obj.isDeal === 0 ? '未处理' : '已处理', // 是否处理
            parentName: obj.parentName, // 设备大类
            posAddress: obj.posAddress, // 详细位置
            supplierName: obj.supplierName, // 厂商名称
            warnTimeStr: obj.warnTimeStr, // 预警时间
            warnTypeName: obj.warnTypeName, // 预警类型
            dealName: obj.dealName, // 处理人
            dealRemark: obj.dealRemark, // 处理备注
            dealResult: obj.dealResult, // 处理结果
            warnMessageCotent: obj.warnMessageCotent
          })
          this.warnTimeStr = obj.warnTimeStr
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.processing{
    margin-top: 20px;
}
.upload{
    max-width: 200px;
    max-height: 200px;
    padding: 0 15px 10px 0;
}
</style>
